import moment from "moment";
import { convertThenFormat } from "../common-data/Converts";

export const closureTbColumns = [
  {
    dataField: "assigned_to name",
    text: <p className="table__header">assigned to name</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.assigned_to_name || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "gym_name",
    text: <p className="table__header">gym name</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.gym_name || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "name",
    text: <p className="table__header">member details</p>,
    formatter: (cell, row) => {
      return (
        <p className="tb-data table__Text">
          <span style={{ display: "block", marginBottom: "8px" }}>
            {row?.name || "NA"}
          </span>
          <span style={{ display: "block", marginBottom: "8px" }}>
            {row?.mobile || "NA"}
          </span>
          <span style={{ display: "block", marginBottom: "5px", textTransform: "lowercase" }}>
            {row?.email || ""}
          </span>
        </p>
      );
    },
  },
  {
    dataField: "cutomer_intent",
    text: <p className="table__header">customer intent</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          <span>{row?.civ_value.replace(/_/g, " ") || "NA"}</span>
          <br />
          <br />

          <small
            style={{
              background:
                row.cutomer_intent?.toLowerCase() === "interested"
                  ? "#379C00"
                  : "#D7263D",
              color: "#fff",
              padding: "5px",
              borderRadius: "4px",
              marginTop: "2px",
              letterSpacing: "1px",
            }}
          >
            {row?.cutomer_intent || "NA"}{" "}
          </small>
        </p>
      );
    },
  },
  {
    dataField: "lead_from",
    text: <p className="table__header">lead from</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.lead_from?.replace(/_/g, " ")?.toUpperCase() || "NA"}
        </p>
      );
    },
  },
  //   {
  //     dataField: "civ_value",
  //     text: <p className="table__header">civ value</p>,
  //     formatter: (cell, row) => {
  //       return (
  //         <p
  //           className="tb-data table__Text "
  //           style={{
  //             textWrap: "wrap",
  //           }}
  //         >
  //           {row?.civ_value || "NA"}
  //         </p>
  //       );
  //     },
  //   },
  {
    dataField: "conversion_date",
    text: <p className="table__header">conversion date</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.conversion_date
            ? moment(row.conversion_date)?.format("DD-MM-YYYY")
            : "-"}
        </p>
      );
    },
  },
  {
    dataField: "conversion_days",
    text: <p className="table__header">conversion days</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.conversion_days || "-"}
        </p>
      );
    },
  },
  {
    dataField: "converted_date",
    text: <p className="table__header">converted date</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.converted_date
            ? moment(row.converted_date)?.format("DD-MM-YYYY")
            : "-"}
        </p>
      );
    },
  },
  {
    dataField: "converted_value",
    text: <p className="table__header">converted value</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.converted_value || 0)}`}
        </p>
      );
    },
  },
  {
    dataField: "current_followup_status",
    text: <p className="table__header">current followup status</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.current_followup_status || "NA"}
        </p>
      );
    },
  },

  {
    dataField: "date_added",
    text: <p className="table__header">date added</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.date_added ? moment(row.date_added)?.format("DD-MM-YYYY") : "-"}
        </p>
      );
    },
  },

  {
    dataField: "is_raw_lead",
    text: <p className="table__header">is raw lead</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.is_raw_lead || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "lead_type",
    text: <p className="table__header">lead type</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.lead_type.replace(/_/g, " ") || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "lead_value",
    text: <p className="table__header">lead value</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {`₹${convertThenFormat(row?.lead_value || 0)}`}
        </p>
      );
    },
  },

  {
    dataField: "next_followup_date",
    text: <p className="table__header">next followup date</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.next_followup_date
            ? moment(row.next_followup_date)?.format("DD-MM-YYYY")
            : "-"}
        </p>
      );
    },
  },
  {
    dataField: "plan_type",
    text: <p className="table__header">plan type</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.plan_type || "NA"}
        </p>
      );
    },
  },
  {
    dataField: "source_name",
    text: <p className="table__header">source name</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.source_name.replace(/_/g, " ") || "NA"}
        </p>
      );
    },
  },
  //   {
  //     dataField: "status",
  //     text: <p className="table__header">status</p>,
  //     formatter: (cell, row) => {
  //       return (
  //         <p
  //           className="tb-data table__Text "
  //           style={{
  //             textWrap: "wrap",
  //           }}
  //         >
  //           {row?.status || "NA"}
  //         </p>
  //       );
  //     },
  //   },
  {
    dataField: "utm_source",
    text: <p className="table__header">utm source</p>,
    formatter: (cell, row) => {
      return (
        <p
          className="tb-data table__Text "
          style={{
            textWrap: "wrap",
          }}
        >
          {row?.utm_source || "NA"}
        </p>
      );
    },
  },
];
